import React, { useEffect, useState, useCallback } from "react";
import { Container, Row, Col, Button, Image, Badge, Stack, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { logout } from "../../utils";
import "./recommendations.css"
import Form from 'react-bootstrap/Form';
import IntegrationWorkflowModal from "../../reusable-components/WorkFlowModals/integrationWorkflowModal"
import IntelligenceWorkflowModal from "../../reusable-components/WorkFlowModals/intelligenceWorkflowModal"
import BotWorkflowModal from "../../reusable-components/WorkFlowModals/botWorkflowModal"
import IntegrationConfirmationModal from "../../reusable-components/WorkFlowModals/integrationConfirmationModal";
import IntelligenceConfirmationModal from "../../reusable-components/WorkFlowModals/intelligenceConfirmationModal";
import AutomationConfirmationModal from "../../reusable-components/WorkFlowModals/automationConfirmationModal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { getFromLS, setToLS } from "../../utils/storage";
import { ToastContainer, toast } from "react-toastify";
import { typeOf } from "react-is";
import Select from 'react-select';

const OptionRenderer = (list) => {
    const options = []
    for (const feature in list) {
        const dict = {}
        dict['id'] = list[feature]
        dict['label'] = list[feature]
        dict['value'] = list[feature]
        options.push(dict)
    }
    return options
}

function listToDict(list, idGen) {
    let dict = {}
    list.forEach((element) => {
        const dictKey = idGen(element)
        dict[dictKey] = element
    })
    return dict
}

const stringLimiter = (string) => {
    let limited_string;
    if (string.length > 30) {
        limited_string = string.substring(0, 27) + "..."
    } else {
        limited_string = string
    }
    return limited_string
}

function getDifference(array1, array2) {
    return array1.filter(object1 => {
        return !array2.some(object2 => {
            return object1.FlowId === object2.FlowId;
        });
    });
}

const DotsConnector = (props) => {
    return (
        <>
            <div className="flowing-loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </>
    );
};

const getAllIntegrationWorkflows = (flowRequestOptions) => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/`, flowRequestOptions)
        .then((response) => {
            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized error
                    logout();
                    alert("Session ended , Please login back");
                } else {
                    throw new Error("Request failed.");
                }
            }
            return response.json();
        })
        .then((data) => {
            const integration_flow = []
            for (let flow in data.data) {
                integration_flow.push(data.data[flow].FlowId)
            }
            setToLS("integration_flows", integration_flow)
        });
};

const getAllIntelWorkflows = (flowRequestOptions) => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/intelligence/`, flowRequestOptions)
        .then((response) => {
            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized error
                    logout();
                    alert("Session ended , Please login back");
                } else {
                    throw new Error("Request failed.");
                }
            }
            return response.json();
        })
        .then((data) => {
            const intelligence_flow = []
            for (let flow in data.data) {
                intelligence_flow.push(data.data[flow].FlowId)
            }
            setToLS("intelligence_flows", intelligence_flow)
        });
};

const getAllAutomationWorkflows = (flowRequestOptions) => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/my_flows/bot/`, flowRequestOptions)
        .then((response) => {
            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized error
                    logout();
                    alert("Session ended , Please login back");
                } else {
                    throw new Error("Request failed.");
                }
            }
            return response.json();
        })
        .then((data) => {
            const automation_flow = []
            for (let flow in data.data) {
                automation_flow.push(data.data[flow].FlowId)
            }
            setToLS("automation_flows", automation_flow)
        });
};

function RecommendedWorkflows(props) {
    let token = localStorage.getItem("token");
    const [integrationApiData, setIntegrationApiData] = useState([])
    const [intelligenceApiData, setIntelligenceApiData] = useState([])
    const [automationApiData, setAutomationApiData] = useState([])
    const [intendedIntegrationRecommendations, setIntendedIntegrationRecommendations] = useState([])
    const [intendedIntelligenceRecommendations, setIntendedIntelligenceRecommendations] = useState([])
    const [intendedAutomationRecommendations, setIntendedAutomationRecommendations] = useState([])
    const [otherIntegrationRecommendations, setOtherIntegrationRecommendations] = useState([])
    const [otherIntelligenceRecommendations, setOtherIntelligenceRecommendations] = useState([])
    const [otherAutomationRecommendations, setOtherAutomationRecommendations] = useState([])
    const [selectedRecommendations, setSelectedRecommendations] = useState([]);
    const [intendedIntegrationRecommendationsDict, setIntendedIntegrationRecommendationsDict] = useState([])
    const [otherIntegrationRecommendationsDict, setOtherIntegrationRecommendationsDict] = useState([])
    const [intendedIntelligenceRecommendationsDict, setIntendedIntelligenceRecommendationsDict] = useState(listToDict(intendedIntelligenceRecommendations, (item) => item.FlowId))
    const [otherIntelligenceRecommendationsDict, setOtherIntelligenceRecommendationsDict] = useState(listToDict(intendedIntelligenceRecommendations, (item) => item.FlowId))
    const [intendedAutomationRecommendationsDict, setIntendedAutomationRecommendationsDict] = useState(listToDict(intendedAutomationRecommendations, (item) => item.FlowId))
    const [otherAutomationRecommendationsDict, setOtherAutomationRecommendationsDict] = useState(listToDict(intendedAutomationRecommendations, (item) => item.FlowId))
    const [isIntegrationEmpty, setIntegrationIsEmpty] = useState(false)
    const [isIntelligenceEmpty, setIntelligenceIsEmpty] = useState(false)
    const [isAutomationEmpty, setAutomationIsEmpty] = useState(false)
    const [intents, setIntents] = useState(getFromLS("intent"))
    const [selectedIntentOptions, setSelectedIntentOptions] = useState(OptionRenderer(intents))

    const [viewMore, setViewMore] = useState(false)
    const intentoptions = [
        
        { value: 'M&A', label: 'Merger and Acquisition' },
        { value: 'Onboarding', label: 'Onboarding' },
        { value: 'Client Sync', label: 'Client Sync' },
        { value: 'Other', label: 'Other' }
    ]

    const [searchText, setSearchText] = useState("");
    const onSearchTextChange = (event) => {
        setSearchText(event.target.value);        
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission if inside a form
            setIntegrationData(integrationApiData, intents)
            setIntelligenceData(intelligenceApiData, intents)
            setAutomationData(automationApiData, intents)
        }
    };

    // Setting page url for helper function
    useEffect(() => {
        setToLS("url", ["recommendations_1", "recommendations_2", "recommendations_3"])
    }, [])

    const setSelectedIntents = (options) => {
        console.log("OPTIONS: ", options)
        setSelectedIntentOptions(options)
        let updated_intents
        if (options != null) {
            updated_intents = [options.value]
        } else {
            updated_intents = []
        }
        setIntents(updated_intents)
        setToLS("intent", updated_intents)
        setIntegrationData(integrationApiData, updated_intents)
        setIntelligenceData(intelligenceApiData, updated_intents)
        setAutomationData(automationApiData, updated_intents)
    }
    useEffect(() => {
        const flowRequestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        getAllIntegrationWorkflows(flowRequestOptions)
        getAllIntelWorkflows(flowRequestOptions)
        getAllAutomationWorkflows(flowRequestOptions)
    }, [])


    useEffect(() => {
        let request_token
        if (getFromLS("token") != null) {
            request_token = getFromLS("token")
        }
        if (token != undefined || token != null) {
            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            };
            // console.log("REQUEST OIPTION: ", requestOptions)

            fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/`, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            // Handle unauthorized error
                            logout();
                            alert("Session ended , Please login back");
                        } else {
                            throw new Error("Request failed.");
                        }
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data.data.length > 0) {
                        console.error("data lenght is - ", data.data.length)
                        setIntegrationData(data, intents)
                    } else {
                        setIntegrationIsEmpty(true)
                    }
                })
            fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/intelligence/`, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            // Handle unauthorized error
                            logout();
                            alert("Session ended , Please login back");
                        } else {
                            throw new Error("Request failed.");
                        }
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data.data.length > 0) {
                        setIntelligenceData(data, intents)
                    } else {
                        setIntelligenceIsEmpty(true)
                    }
                })

            fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/bot/`, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401) {
                            // Handle unauthorized error
                            logout();
                            alert("Session ended , Please login back");
                        } else {
                            throw new Error("Request failed.");
                        }
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data.data.length > 0) {
                        setAutomationData(data, intents)
                    } else {
                        setAutomationIsEmpty(true)
                    }
                })
        } else {
            console.log("TOKEN NOT FOUND!")
        }
    }, []);

    const setIntegrationData = (data, intents) => {
        console.log("API DATA: ", data["data"])
        if (data.data.length > 0) {
            setIntegrationIsEmpty(false)
            setIntegrationApiData(data)
            const integration_api_data = data["data"]
            const intended_recommendations = integration_api_data.filter(obj => {
                return (intents || []).some(intent => obj.BusinessIntent.includes(intent))
            })
            const other_recommendations = getDifference(integration_api_data, intended_recommendations);
            // console.log("All integration recommendation:", integration_api_data)
            // console.log("Intended integration recommendation:", intended_recommendations)
            // console.log("Other integration recommendation:", other_recommendations)
            const filtered_intended_recommendations = intended_recommendations.filter(rec => {
                return rec.FlowName.toLowerCase().includes(searchText.toLowerCase())
            });
    
            const filtered_other_recommendations = other_recommendations.filter(rec => {
                return rec.FlowName.toLowerCase().includes(searchText.toLowerCase())
            });
            const all_intended_recommendations_dict = listToDict(filtered_intended_recommendations, (item) => item.FlowId)
            setIntendedIntegrationRecommendations(filtered_intended_recommendations)
            setIntendedIntegrationRecommendationsDict(all_intended_recommendations_dict)
            const all_other_recommendations_dict = listToDict(filtered_other_recommendations, (item) => item.FlowId)
            setOtherIntegrationRecommendations(filtered_other_recommendations)
            setOtherIntegrationRecommendationsDict(all_other_recommendations_dict)
        } else {
            console.log("EMPTY RESULT SET!")
        }

    }

    const setIntelligenceData = (data, intents) => {
        // console.log("API DATA: ", data["data"])
        if (data.data.length > 0) {
            setIntelligenceIsEmpty(false)
            setIntelligenceApiData(data)
            const intelligence_api_data = data["data"]
            const intended_recommendations = intelligence_api_data.filter(obj => {
                return (intents || []).some(intent => obj.BusinessIntent.includes(intent))
            })
            const other_recommendations = getDifference(intelligence_api_data, intended_recommendations);
            // console.log("Intended intelligence recommendation:", intended_recommendations)
            const filtered_intended_recommendations = intended_recommendations.filter(rec => {
                return rec.FlowName.toLowerCase().includes(searchText.toLowerCase())
            });
            
            const filtered_other_recommendations = other_recommendations.filter(rec => {
                return rec.FlowName.toLowerCase().includes(searchText.toLowerCase())
            });
            const all_intended_recommendations_dict = listToDict(filtered_intended_recommendations, (item) => item.FlowId)
            setIntendedIntelligenceRecommendations(filtered_intended_recommendations)
            setIntendedIntelligenceRecommendationsDict(all_intended_recommendations_dict)
            
            // console.log("Other intelligence recommendation:", other_recommendations)
            const all_other_recommendations_dict = listToDict(filtered_other_recommendations, (item) => item.FlowId)
            setOtherIntelligenceRecommendations(filtered_other_recommendations)
            setOtherIntelligenceRecommendationsDict(all_other_recommendations_dict)
        } else {
            console.log("EMPTY RESULT SET!")
        }

    }

    const setAutomationData = (data, intents) => {
        // console.log("API DATA: ", data["data"])
        if (data.data.length > 0) {
            setAutomationIsEmpty(false)
            setAutomationApiData(data)
            const automation_api_data = data["data"]
            const intended_recommendations = automation_api_data.filter(obj => {
                return (intents || []).some(intent => obj.BusinessIntent.includes(intent))
            })
            const other_recommendations = getDifference(automation_api_data, intended_recommendations);

            const filtered_intended_recommendations = intended_recommendations.filter(rec => {
                return rec.FlowName.toLowerCase().includes(searchText.toLowerCase())
            });
    
            const filtered_other_recommendations = other_recommendations.filter(rec => {
                return rec.FlowName.toLowerCase().includes(searchText.toLowerCase())
            });
            // console.log("Intended automation recommendation:", intended_recommendations)
            const all_intended_recommendations_dict = listToDict(filtered_intended_recommendations, (item) => item.FlowId)
            setIntendedAutomationRecommendations(filtered_intended_recommendations)
            setIntendedAutomationRecommendationsDict(all_intended_recommendations_dict)
            
            // console.log("Other automation recommendation:", other_recommendations)
            const all_other_recommendations_dict = listToDict(filtered_other_recommendations, (item) => item.FlowId)
            setOtherAutomationRecommendations(filtered_other_recommendations)
            setOtherAutomationRecommendationsDict(all_other_recommendations_dict)
        } else {
            console.log("EMPTY RESULT SET!")
        }

    }

    const integrationWorkflowSave = (props) => {
        let payloadFormat;
        payloadFormat = {
            "FlowId": props.workflow.FlowId,
            "FlowName": props.workflow.FlowName
        }
        console.log("PAYLOAD FORMAT: ", payloadFormat)
        const postOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payloadFormat),
        };

        fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/`, postOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        // Handle unauthorized error
                        logout();
                        alert("Session ended , Please login back");
                    } else {
                        throw new Error("Request failed.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                console.log("data successfully saved", data);
                if (data.success == true) {
                    toast.success(
                        props.workflow.FlowName + " successfully saved!",
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-success",
                        }
                    );
                } else {
                    toast.error(
                        "Saving failed, " + data.message,
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-error",
                        }
                    );
                }
                // setTimeout(() => {
                //     transporter("myflows")
                // }, 3000);
            })
            .catch((err) => console.log("Err: ", err));
    }

    const intelligenceWorkflowSave = (props) => {
        let payloadFormat = {
            "FlowId": props.workflow.FlowId,
            "FlowName": props.workflow.FlowName,
            "SelectedReports": [],
            "OutputExtensions": [],
        };
        console.log("PAYLOAD FORMAT: ", payloadFormat)
        const postOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payloadFormat),
        };

        fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/intelligence/`, postOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        // Handle unauthorized error
                        logout();
                        alert("Session ended , Please login back");
                    } else {
                        throw new Error("Request failed.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                // console.log("data successfully saved", data);
                if (data.success == true) {
                    toast.success(
                        props.workflow.FlowName + " successfully saved!",
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-success",
                        }
                    );
                } else {
                    toast.error(
                        "Saving failed, " + data.message,
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-error",
                        }
                    );
                }

                // setTimeout(() => {
                //     transporter("myflows")
                // }, 3000);
            })
            .catch((err) => console.log("Err: ", err));
    }

    const automationWorkflowSave = (props) => {
        const payloadFormat = {
            "FlowId": props.workflow.FlowId,
            "FlowName": props.workflow.FlowName,
            "SourceUsername": "",
            "SourcePassword": "",
            "TargetUsername": "",
            "TargetPassword": "",
            "Schedule": {
                // "Recurring": schedulerFormcontext[label_id_map["Recurring"]].value,
                "Units": "",
                "RunEvery": "",
                "StartDate": "",
                "EndDate": "",
                "RepeatDay": []
            }
        }
        console.log("Payload Format: ", payloadFormat)

        const postOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payloadFormat),
        };

        fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_flows/bot/`, postOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        // Handle unauthorized error
                        logout();
                        alert("Session ended , Please login back");
                    } else {
                        throw new Error("Request failed.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                // console.log("data successfully saved", data);
                if (data.success == true) {
                    toast.success(
                        props.workflow.FlowName + " successfully saved!",
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-success",
                        }
                    );
                } else {
                    toast.error(
                        "Saving failed, " + data.message,
                        {
                            position: "bottom-right",
                            autoClose: 2500,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            className: "toastify-color-error",
                        }
                    );
                }
                // setTimeout(() => {
                //     transporter("myflows")
                // }, 3000);
            })
            .catch((err) => console.log("Err: ", err));
    }

    // Recommended flow card renderer
    const IntegrationRecommendationCard = props => {
        const [toggleIcon, setToggleIcon] = useState(false)
        const [confirmationModal, setConfirmationModal] = useState(false)
        const handleDialogOpen = () => setConfirmationModal(true);
        // prevent function being recreated on state change
        const handleDialogClose = useCallback(() => setConfirmationModal(false), []);

        const toggle = () => {
            const isTrue = handleIntegrationWorkflowSave(props)
            setToggleIcon(isTrue)
        }
        const setToggle = (isTrue) => {
            setToggleIcon(isTrue)
        }

        const skiporsave = (flag, flowtype, props) => {
            if (flag) {
                integrationWorkflowSave(props)
                setConfirmationModal(false)
            } else {
                setConfirmationModal(false)
            }
        }
        const handleIntegrationWorkflowSave = (props) => {
            console.log("INTEGRATION SAVE PROPS: ", props)
            const available_integration_workflows = getFromLS("integration_flows")
            if (available_integration_workflows.includes(props.id)) {
                console.log("Flow already exists!")
                handleDialogOpen()
                return true
            } else {
                console.log("New flow will be added!")
                integrationWorkflowSave(props)
                return true
            }
            // console.log("INTEGRATION DATA: ", data)
            // console.log("INTEGRATION SCHEDULE: ", schedulerFormcontext)
            // const daymap = []
            // const daylist = []
            // let field_id_label_map = {}
            // let label_id_map = {}
            // for (let field_index in data) {
            //     Object.assign(field_id_label_map, { [data[field_index].label]: parseInt(field_index) })
            //     if (data[field_index].type == "daypicker")
            //         daymap.push({ [data[field_index].label]: data[field_index].value })
            // }
            // for (let field_index in schedulerFormcontext) {
            //     Object.assign(label_id_map, { [schedulerFormcontext[field_index].label]: parseInt(field_index) })
            //     if (schedulerFormcontext[field_index].type == "daypicker")
            //         daymap.push({ [schedulerFormcontext[field_index].label]: schedulerFormcontext[field_index].value })
            // }
            // // console.log("LABEL ID MAP: ", label_id_map)
            // for (let day in daymap) {
            //     Object.entries(daymap[day]).find(([key, value]) => {
            //         if (value === true) {
            //             daylist.push(key)
            //         }
            //     });
            // }
            // if (scheduleSchema) {
            //     payloadFormat = {
            //         "FlowId": workflowid ,
            //         "FlowName": data[field_id_label_map["Flow Name"]].value,
            //         "Schedule": {
            //             // "Recurring": schedulerFormcontext[label_id_map["Recurring"]].value,
            //             "Units": schedulerFormcontext[label_id_map["Units"]].value,
            //             "RunEvery": schedulerFormcontext[label_id_map["Repeat after"]].value,
            //             "StartDate": schedulerFormcontext[label_id_map["Starts"]].value.toUTCString(),
            //             "EndDate": schedulerFormcontext[label_id_map["Ends"]].value.toUTCString(),
            //             "RepeatDay": daylist
            //         }
            //     }
            // } else {
            // payloadFormat = {
            //     "FlowId": workflowid,
            //     "FlowName": data[field_id_label_map["Flow Name"]].value,
            // }
            // }
        };

        // const showIntegrationWorkflowModal = () => setModalState(true)
        // const handleChange = (option) =>{
        //     console.log("SELECTED FLOW: ", option)
        // }

        return (
            <>
                <IntegrationConfirmationModal
                    show={confirmationModal}
                    onHide={handleDialogClose}
                    props={props}
                    skiporsave={skiporsave}
                    toggleicon={setToggle}
                />
                <Col md={3}>
                    <div className="workflow-wrapper">
                        <Row>
                            <Col md={10}>
                                <Stack direction="horizontal" gap={2} className="badge-info">
                                    {props.workflow.BusinessIntent.map(obj => (
                                        <Badge
                                            className="workflow-badge"
                                            text="light"
                                            style={{ fontSize: "var(--small_font)", fontWeight: 400 }}
                                            key={obj}
                                        >
                                            {obj}
                                        </Badge>
                                    ))}
                                </Stack>
                                <div className="workflow-description">
                                    <p className="flow-name">{stringLimiter(props.workflow.FlowName)}</p>
                                </div>
                                <div className="workflow-logo-wrapper">
                                    <Image src={props.workflow.SourceVendorLogoLink} className="vendor-logo-mini" rounded />
                                    <DotsConnector />
                                    <Image src={props.workflow.TargetVendorLogoLink} className="vendor-logo-mini" rounded />
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="workflow-modal-popper">
                                    {toggleIcon ? <Icon.CheckCircleFill className="add-icon disabled" /> : <Icon.PlusCircleFill className="add-icon" onClick={() => toggle()} />}
                                    <div id="show-description" className="show-description">
                                        <Icon.QuestionCircleFill className="info-icon" />
                                    </div>
                                    <div id="overlay" className="overlay">
                                        <span>
                                            <p className="flow-name">{props.workflow.FlowName}</p>
                                            <p>{props.workflow.FlowDescription}</p>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </div>
                </Col>
            </>
        )
    }

    const IntelligenceRecommendationCard = props => {
        // console.log("INTELLIGENCE RECOMMENDATION CARD PROPS: ", props)
        const [toggleIcon, setToggleIcon] = useState(false)
        const [confirmationModal, setConfirmationModal] = useState(false)
        const handleDialogOpen = () => setConfirmationModal(true);
        // prevent function being recreated on state change
        const handleDialogClose = useCallback(() => setConfirmationModal(false), []);

        const toggle = () => {
            const isTrue = handleIntelligenceWorkflowSave(props)
            setToggleIcon(isTrue)
        }
        const setToggle = (isTrue) => {
            setToggleIcon(isTrue)
        }

        const skiporsave = (flag, flowtype, props) => {
            if (flag) {
                integrationWorkflowSave(props)
                setConfirmationModal(false)
            } else {
                setConfirmationModal(false)
            }
        }
        const sourceVendors = props.workflow.SourceVendors
        const handleIntelligenceWorkflowSave = (props) => {
            console.log("INTELLIGENCE SAVE PROPS: ", props)
            const available_intelligence_workflows = getFromLS("intelligence_flows")
            if (available_intelligence_workflows.includes(props.id)) {
                console.log("Flow already exists!")
                handleDialogOpen()
                return true
            } else {
                console.log("New flow will be added!")
                intelligenceWorkflowSave(props)
                return true
            }
            // console.log("BOT SOURCE DATA: ", extensiondata)
            // console.log("BOT TARGET DATA: ", reportdata)
            // console.log("SCHEDULER SCHEMA: ", scheduleSchema)
            // console.log("BOT SCHEDULER DATA: ", schedulerFormcontext)
            // const selected_reports = []
            // const selected_extensions = []
            // const daymap = []
            // const daylist = []
            // let label_id_map = {}
            // for (let field_index in schedulerFormcontext) {
            //     Object.assign(label_id_map, { [schedulerFormcontext[field_index].label]: parseInt(field_index) })
            //     if (schedulerFormcontext[field_index].type == "daypicker")
            //         daymap.push({ [schedulerFormcontext[field_index].label]: schedulerFormcontext[field_index].value })
            // }
            // // console.log("LABEL ID MAP: ", label_id_map)
            // for (let day in daymap) {
            //     Object.entries(daymap[day]).find(([key, value]) => {
            //         if (value === true) {
            //             daylist.push(key)
            //         }
            //     });
            // }

            // for (let field_index in reportdata) {
            //     if (reportdata[field_index].value == true) {
            //         selected_reports.push(reportdata[field_index].label)
            //     }
            //     else {
            //         continue;
            //     }
            // }
            // for (let field_index in extensiondata) {
            //     if (extensiondata[field_index].value == true) {
            //         selected_extensions.push(extensiondata[field_index].label)
            //     }
            //     else {
            //         continue;
            //     }
            // }

            // if (scheduleSchema && schedulerFormcontext.length > 1) {
            //     payloadFormat = {
            //         "FlowId": workflowid,
            //         "FlowName": workflowname,
            //         "SelectedReports": selected_reports,
            //         "OutputExtensions": selected_extensions,
            //         "Schedule": {
            //             // "Recurring": schedulerFormcontext[label_id_map["Recurring"]].value,
            //             "Units": schedulerFormcontext[label_id_map["Units"]].value,
            //             "RunEvery": schedulerFormcontext[label_id_map["Repeat after"]].value,
            //             "StartDate": schedulerFormcontext[label_id_map["Starts"]].value.toUTCString(),
            //             "EndDate": schedulerFormcontext[label_id_map["Ends"]].value.toUTCString(),
            //             "RepeatDay": daylist
            //         }
            //     }
            // } else {
            //     payloadFormat = {
            //         "FlowId": workflowid,
            //         "FlowName": workflowname,
            //         "SelectedReports": selected_reports,
            //         "OutputExtensions": selected_extensions,
            //     }
            // }
            // console.log("PAYLOAD FORMAT: ", payloadFormat)
        };
        return (
            <>
                <IntelligenceConfirmationModal
                    show={confirmationModal}
                    onHide={handleDialogClose}
                    props={props}
                    skiporsave={skiporsave}
                    toggleicon={setToggle}
                />
                <Col md={3} className="text-center">
                    <div className="workflow-wrapper">
                        <Row>
                            <Col md={10}>
                                <Stack direction="horizontal" gap={2} className="badge-info">
                                    {props.workflow.BusinessIntent.map(obj => (
                                        <Badge
                                            className="workflow-badge"
                                            text="light"
                                            style={{ fontSize: "var(--small_font)" }}
                                            key={obj}
                                        >
                                            {obj}
                                        </Badge>
                                    ))}
                                </Stack>
                                <div className="workflow-description">
                                    <p className="flow-name">{stringLimiter(props.workflow.FlowName)}</p>
                                </div>
                                <div className="workflow-logo-wrapper">
                                    {
                                        sourceVendors.length > 1
                                            ?
                                            <div className="vendor-logo-mini">
                                                <Icon.UiRadios className="multi-vendor-logo" />
                                            </div>
                                            :
                                            <Image src={props.workflow.SourceVendors[0].VendorLogoLink} className="vendor-logo-mini" rounded />
                                    }
                                    <DotsConnector />
                                    <Image src={props.workflow.TargetVendors[0].VendorLogoLink} className="vendor-logo-mini" rounded />
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="workflow-modal-popper">
                                    {toggleIcon ? <Icon.CheckCircleFill className="add-icon disabled" /> : <Icon.PlusCircleFill className="add-icon" onClick={() => toggle()} />}
                                    <div id="show-description" className="show-description">
                                        <Icon.QuestionCircleFill className="info-icon" />
                                    </div>
                                    <div id="overlay" className="overlay">
                                        <span>
                                            <p className="flow-name">{props.workflow.FlowName}</p>
                                            <p>{props.workflow.FlowDescription}</p>
                                        </span>
                                    </div>
                                </div>
                            </Col>

                        </Row>
                    </div>
                </Col>
            </>
        )
    }

    const BotRecommendationCard = props => {
        const [toggleIcon, setToggleIcon] = useState(false)
        const [confirmationModal, setConfirmationModal] = useState(false)
        const handleDialogOpen = () => setConfirmationModal(true);
        // prevent function being recreated on state change
        const handleDialogClose = useCallback(() => setConfirmationModal(false), []);

        const toggle = () => {
            const isTrue = handleBotWorkflowSave(props)
            setToggleIcon(isTrue)
        }
        const setToggle = (isTrue) => {
            setToggleIcon(isTrue)
        }

        const skiporsave = (flag, flowtype, props) => {
            if (flag) {
                integrationWorkflowSave(props)
                setConfirmationModal(false)
            } else {
                setConfirmationModal(false)
            }
        }
        const handleBotWorkflowSave = (props) => {
            console.log("AUTOMATION SAVE PROPS: ", props)
            const available_automation_workflows = getFromLS("automation_flows")
            if (available_automation_workflows.includes(props.id)) {
                console.log("Flow already exists!")
                handleDialogOpen()
                return true
            } else {
                console.log("New flow will be added!")
                automationWorkflowSave(props)
                return true
            }
            // console.log("BOT SOURCE DATA: ", sourcedata)
            // console.log("BOT TARGET DATA: ", targetdata)
            // console.log("BOT SCHEDULER DATA: ", schedulerFormcontext)
            // let source_label_id_map = {}
            // let target_label_id_map = {}
            // let label_id_map = {}
            // const daymap = []
            // const daylist = []
            // for (let field_index in sourcedata) {
            //     Object.assign(source_label_id_map, { [sourcedata[field_index].label]: parseInt(field_index) })
            // }
            // for (let field_index in targetdata) {
            //     Object.assign(target_label_id_map, { [targetdata[field_index].label]: parseInt(field_index) })
            // }

            // for (let field_index in schedulerFormcontext) {
            //     Object.assign(label_id_map, { [schedulerFormcontext[field_index].label]: parseInt(field_index) })
            //     if (schedulerFormcontext[field_index].type == "daypicker")
            //         daymap.push({ [schedulerFormcontext[field_index].label]: schedulerFormcontext[field_index].value })
            // }
            // // console.log("LABEL ID MAP: ", label_id_map)
            // for (let day in daymap) {
            //     Object.entries(daymap[day]).find(([key, value]) => {
            //         if (value === true) {
            //             daylist.push(key)
            //         }
            //     });
            // }
            // const payloadFormat = {
            //     "FlowId": workflowid,
            //     "FlowName": workflowname,
            //     "SourceUsername": sourcedata[source_label_id_map["Username"]].value,
            //     "SourcePassword": sourcedata[source_label_id_map["Password"]].value,
            //     "TargetUsername": targetdata[target_label_id_map["Username"]].value,
            //     "TargetPassword": targetdata[target_label_id_map["Password"]].value,
            //     "Schedule": {
            //         // "Recurring": schedulerFormcontext[label_id_map["Recurring"]].value,
            //         "Units": schedulerFormcontext[label_id_map["Units"]].value,
            //         "RunEvery": schedulerFormcontext[label_id_map["Repeat after"]].value,
            //         "StartDate": schedulerFormcontext[label_id_map["Starts"]].value.toUTCString(),
            //         "EndDate": schedulerFormcontext[label_id_map["Ends"]].value.toUTCString(),
            //         "RepeatDay": daylist
            //     }
            // }
            // if (sourcedata.length > 2) {
            //     // console.log("SOURCE ID LABEL MAP: ", source_label_id_map)
            //     for (let field in sourcedata) {
            //         if (sourcedata[field].label != "Username" && sourcedata[field].label != "Password")
            //             Object.assign(payloadFormat, { ["Source_" + sourcedata[field].label]: sourcedata[source_label_id_map[sourcedata[field].label]].value })
            //     }
            // }
            // if (targetdata.length > 2) {
            //     // console.log("TARGET ID LABEL MAP: ", target_label_id_map)
            //     for (let field in targetdata) {
            //         if (targetdata[field].label != "Username" && targetdata[field].label != "Password")
            //             Object.assign(payloadFormat, { ["Target_" + targetdata[field].label]: targetdata[target_label_id_map[targetdata[field].label]].value })
            //     }
            // }

        };
        return (
            <>
                <AutomationConfirmationModal
                    show={confirmationModal}
                    onHide={handleDialogClose}
                    props={props}
                    skiporsave={skiporsave}
                    toggleicon={setToggle}
                />
                <Col md={3} className="text-center">
                    <div className="workflow-wrapper">
                        <Row>
                            <Col md={10}>
                                <Stack direction="horizontal" gap={2} className="badge-info">
                                    {props.workflow.BusinessIntent.map(obj => (
                                        <Badge
                                            className="workflow-badge"
                                            text="light"
                                            style={{ fontSize: "var(--small_font)" }}
                                            key={obj}
                                        >
                                            {obj}
                                        </Badge>
                                    ))}
                                </Stack>
                                <div className="workflow-description">
                                    <p className="flow-name">{stringLimiter(props.workflow.FlowName)}</p>
                                </div>
                                <div className="workflow-logo-wrapper">
                                    <Image src={props.workflow.SourceVendors[0].VendorLogoLink} className="vendor-logo-mini" rounded />
                                    <DotsConnector />
                                    <Image src={props.workflow.TargetVendors[0].VendorLogoLink} className="vendor-logo-mini" rounded />
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="workflow-modal-popper">
                                    {toggleIcon ? <Icon.CheckCircleFill className="add-icon disabled" /> : <Icon.PlusCircleFill className="add-icon" onClick={() => toggle()} />}
                                    <div id="show-description" className="show-description">
                                        <Icon.QuestionCircleFill className="info-icon" />
                                    </div>
                                    <div id="overlay" className="overlay">
                                        <p className="flow-name">{props.workflow.FlowName}</p>
                                        <p>{props.workflow.FlowDescription}</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </>
        )
    }

    const transporter = (pill) => {
        props.transporter(pill);
        
    };

    

    return (
        <>
            <Row className="no-gutter recommendation-title-holder">
                <Col md={6}>
                    <div className="recommendation-title">
                        <p className="display-6">Recommendations</p>
                    </div>
                </Col>
            </Row>
            <Row className="align-items-center justify-content-end" 
                style={{ 
                    display: "flex",
                    position: "absolute",
                    right: "0px",
                    width: "100%",
                    marginTop: "-30px"
                }}
            >
                {/* Navigation Buttons on the Right */}
                <Col md={3} className="d-flex justify-content-end">
                    <Button className="nav-direction me-2" onClick={() => transporter("myapps")}>
                        <Icon.CaretLeftFill /> My Apps
                    </Button>
                    <Button className="nav-direction" onClick={() => transporter("myflows")}>
                        My Flows <Icon.CaretRightFill />
                    </Button>
                </Col>
            </Row>
            <Row className="align-items-center justify-content-end" 
                style={{ 
                    display: "flex",
                    position: "absolute",
                    right: "10px",
                    width: "40%",
                    marginTop: "10px"
                }}
            >
                {/* Intent Dropdown on the Left */}
                <Col md={2} className="d-flex align-items-center"
                    style={{
                        width: "30%"
                    }}
                >
                    <Select
                        defaultValue={selectedIntentOptions}
                        onChange={(e) => setSelectedIntents(e)}
                        options={intentoptions}
                        className="intent-select custom-select"
                        aria-label="Default"
                        closeMenuOnSelect={true}
                        placeholder="Filter by intent"
                        menuPosition="fixed"
                        classNamePrefix="react-select"
                        isClearable
                    />
                </Col>

                {/* Search Bar Covering Center */}
                <Col md={2} className="position-relative"
                    style={{
                        width: "70%"
                    }}
                >
                    <Form.Control
                        type="text"
                        className="form-control custom-input"
                        placeholder="Search"
                        value={searchText}
                        onChange={onSearchTextChange}
                        onKeyDown={handleKeyPress}
                        style={{
                            width: "100%",
                            maxWidth: "100%",
                            paddingRight: "40px",
                        }}
                    />
                    <Icon.Search
                        className="search-icon"
                        onClick={() => {
                            setIntegrationData(integrationApiData, intents);
                            setIntelligenceData(intelligenceApiData, intents);
                            setAutomationData(automationApiData, intents);
                        }}
                        style={{
                            position: "absolute",
                            top: "50%",
                            right: "20px",
                            transform: "translateY(-50%)",
                            fontSize: "16px",
                            color: "#888",
                            cursor: "pointer",
                        }}
                    />
                </Col>
            </Row>

            <Row className="no-gutter" style={{paddingLeft: 15, marginTop: 15}}>
                <Tabs
                    defaultActiveKey="integrationWorkflows"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >

                    <Tab eventKey="integrationWorkflows" title={"Integration flows"} className="tabs">
                        <Row style={{marginLeft: -30, overflowY: "auto", overflowX: "hidden", maxHeight: "77vh"}}>
                            {/* <h2>Recommended Integration Flows for you </h2>
                        <hr /> */}
                            {
                                isIntegrationEmpty
                                    ?
                                    <div className="empty-message text-center">
                                        <h6>We have no recommended Integration Flows for the selected applications.
                                            <br /> Please select other applications</h6>
                                    </div>
                                    : <>
                                        {
                                            intendedIntegrationRecommendations.length > 0 ?
                                                <>
                                                    <Row className={"no-gutter"} >
                                                        <h6 style={{paddingLeft: 20}}>Recommended flows based on intent and selected vendors </h6>
                                                        {intendedIntegrationRecommendations &&
                                                            intendedIntegrationRecommendations.map(option => (
                                                                <IntegrationRecommendationCard
                                                                    workflow={intendedIntegrationRecommendationsDict[option.FlowId]}
                                                                    key={intendedIntegrationRecommendationsDict[option.FlowId].FlowId}
                                                                    id={intendedIntegrationRecommendationsDict[option.FlowId].FlowId}
                                                                />
                                                            ))}
                                                    </Row>
                                                    {/* <Button className="intent-skip" onClick={() => setViewMore(!viewMore)}> {!viewMore ? <>See more <Icon.ArrowDown /></> : <>See less <Icon.ArrowUp /></>} </Button> */}
                                                </>
                                                :
                                                <></>
                                        }
                                    </>
                            }
                            {intendedIntegrationRecommendations.length > 0 ? <hr className="hr-divider"></hr> : <></>}
                            <div className={intendedIntegrationRecommendations.length > 0 ? "padt20" : ""}>
                                {
                                    otherIntegrationRecommendations.length > 0 ?
                                        <Row className={"no-gutter"} >
                                            {intendedIntegrationRecommendations.length > 0 ?
                                                <h6>Other flows based on selected vendors</h6> : <></>}
                                            {otherIntegrationRecommendations &&
                                                otherIntegrationRecommendations.map(option => (
                                                    <IntegrationRecommendationCard
                                                        workflow={otherIntegrationRecommendationsDict[option.FlowId]}
                                                        key={otherIntegrationRecommendationsDict[option.FlowId].FlowId}
                                                        id={otherIntegrationRecommendationsDict[option.FlowId].FlowId}
                                                    />
                                                ))}
                                        </Row>
                                        :
                                        <></>
                                }
                            </div>
                        </Row>
                    </Tab>
                    <Tab eventKey="intelligenceWorkflows" title={"Intelligence flows"} className="tabs">
                        <Row style={{marginLeft: -30, overflowY: "auto", overflowX: "hidden", maxHeight: "77vh"}}>
                            {
                                isIntelligenceEmpty
                                    ?
                                    <div className="empty-message text-center">
                                        <h6>We have no recommended Intelligence Flows for the selected applications.
                                            <br /> Please select other applications</h6>
                                    </div>
                                    : <>
                                        {
                                            intendedIntelligenceRecommendations.length > 0 ?
                                                <Row className={"no-gutter"} >
                                                    <h6 style={{paddingLeft: 20}}>Recommended flows based on intent and selected vendors </h6>
                                                    {intendedIntelligenceRecommendations &&
                                                        intendedIntelligenceRecommendations.map(option => (
                                                            <IntelligenceRecommendationCard
                                                                workflow={intendedIntelligenceRecommendationsDict[option.FlowId]}
                                                                key={intendedIntelligenceRecommendationsDict[option.FlowId].FlowId}
                                                                id={intendedIntelligenceRecommendationsDict[option.FlowId].FlowId}
                                                            />
                                                        ))}
                                                </Row> :
                                                <></>
                                        }
                                    </>
                            }
                            {intendedIntelligenceRecommendations.length > 0 ? <hr className="hr-divider"></hr> : <></>}
                            <div className={intendedIntelligenceRecommendations.length > 0 ? "padt20" : ""}>
                                {
                                    otherIntelligenceRecommendations.length > 0 ?
                                        <Row className={"no-gutter"} >
                                            {intendedIntelligenceRecommendations.length > 0 ?
                                                <h6>Other flows based on selected vendors</h6> : <></>}
                                            {otherIntelligenceRecommendations &&
                                                otherIntelligenceRecommendations.map(option => (
                                                    <IntelligenceRecommendationCard
                                                        workflow={otherIntelligenceRecommendationsDict[option.FlowId]}
                                                        key={otherIntelligenceRecommendationsDict[option.FlowId].FlowId}
                                                        id={otherIntelligenceRecommendationsDict[option.FlowId].FlowId}
                                                    />
                                                ))}
                                        </Row>
                                        :
                                        <></>
                                }
                            </div>
                        </Row>
                    </Tab>
                    <Tab eventKey="botWorkflows" title={"Automation flows"} className="tabs">
                        <Row style={{marginLeft: -30, overflowY: "auto", overflowX: "hidden", maxHeight: "77vh"}}>
                            {
                                isAutomationEmpty
                                    ?
                                    <div className="empty-message text-center">
                                        <h6>We have no recommended Automation Flows for the selected applications.
                                            <br /> Please select other applications</h6>
                                    </div>
                                    :
                                    <>
                                        {
                                            intendedAutomationRecommendations.length > 0 ?
                                                <Row className={"no-gutter"}>
                                                    <h6 style={{paddingLeft: 20}}>Recommended flows based on intent and selected vendors </h6>
                                                    {intendedAutomationRecommendations &&
                                                        intendedAutomationRecommendations.map(option => (
                                                            <BotRecommendationCard
                                                                workflow={intendedAutomationRecommendationsDict[option.FlowId]}
                                                                key={intendedAutomationRecommendationsDict[option.FlowId].FlowId}
                                                                id={intendedAutomationRecommendationsDict[option.FlowId].FlowId}
                                                            />
                                                        ))}
                                                </Row> :
                                                <></>
                                        }
                                    </>
                            }
                            {intendedAutomationRecommendations.length > 0 ? <hr className="hr-divider"></hr> : <></>}
                            <div className={intendedAutomationRecommendations.length > 0 ? "padt20" : ""}>
                                {
                                    otherAutomationRecommendations.length > 0 ?
                                        <Row className={"no-gutter"}>
                                            {intendedAutomationRecommendations.length > 0 ?
                                                <h6>Other flows based on selected vendors</h6> : <></>}
                                            {otherAutomationRecommendations &&
                                                otherAutomationRecommendations.map(option => (
                                                    <BotRecommendationCard
                                                        workflow={otherAutomationRecommendationsDict[option.FlowId]}
                                                        key={otherAutomationRecommendationsDict[option.FlowId].FlowId}
                                                        id={otherAutomationRecommendationsDict[option.FlowId].FlowId}
                                                    />
                                                ))}
                                        </Row>
                                        :
                                        <></>
                                }
                            </div>
                        </Row>
                    </Tab>
                </Tabs>
            </Row>
        </>
    );
}

export default RecommendedWorkflows;
